import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
// import { DccService } from 'src/app/services/dcc/dcc.service';
import { HistoryManager } from 'src/app/services/history-manager/history-manager.service';
import { LoggerService } from 'src/app/services/logger/logger.service';
import { VantageShellService } from 'src/app/services/vantage-shell/vantage-shell.service';
import {
	containerAppService,
	SubApp,
} from '@lenovo/micro-frontends-iframe/container-app/container-app.service';
import { SubAppLoadType } from '@lenovo/micro-frontends-iframe/container-app/sub-app-load-type.enum';

@Component({
	selector: 'vtr-widget-sub-app-transition',
	templateUrl: './widget-sub-app-transition.component.html',
	styleUrls: ['./widget-sub-app-transition.component.scss'],
})
export class WidgetSubAppTransitionComponent implements OnInit, OnDestroy {
	@Input() subApp: SubApp;
	@Input() showSkeleton = false;
	@Input() metricsParent = '';
	@Input() title = '';
	backArrow = '< ';
	private isSubAppIframeLoadedSubscription: Subscription;
	public isSubAppIframeShowed = true;
	private routerEventSubscription: Subscription;

	constructor(
		private historyManager: HistoryManager,
		// public dccService: DccService,
		private vantageShellService: VantageShellService,
		private router: Router,
		private logger: LoggerService
	) {}

	ngOnInit() {
		const { state: subAppState } = this.subApp;

		this.isSubAppIframeLoadedSubscription = subAppState.successfullyLoadedSubject.subscribe(
			(isSuccessfullyLoaded) => {
				this.logger.info(
					`subAppTransitionPage[${this.subApp.name}isSuccessfullyLoaded app]`,isSuccessfullyLoaded
				);
				if (isSuccessfullyLoaded) {
					const currentUrl = window.location.href;
					const currentSubAppSubUrl = currentUrl.substring(
						(window.location.origin + window.location.pathname).length + 1
					);
					containerAppService.navigateInSubApp(this.subApp, currentSubAppSubUrl);
					containerAppService.showSubApp(this.subApp.name);
					this.isSubAppIframeShowed = true;
				}
			}
		);
		this.logger.info(
			`subAppTransitionPage[${this.subApp.name} app]`,
			subAppState.isIframeExisted ? 'already load before' : 'not load yet, now load'
		);
		containerAppService.loadSubApp(this.subApp, SubAppLoadType.NonPreload);

		if (
			this.vantageShellService.isShellAvailable &&
			!window.VantageShellExtension?.MsWebviewHelper?.getInstance()?.isInOfflineMode
		) {
			containerAppService.handleSubAppLoadTimeout(this.subApp);
		}
		this.routerEventSubscription = this.router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
				containerAppService.navigateInSubApp(this.subApp, event.url);
			}
		});
	}

	ngOnDestroy() {
		containerAppService.hideSubApp(this.subApp.name);
		this.isSubAppIframeShowed = false;
		this.isSubAppIframeLoadedSubscription?.unsubscribe();
		this.routerEventSubscription?.unsubscribe();
	}

	public goBack() {
		return this.historyManager.goBack();
	}
}
